import React from "react";
import "./NoMatch.css";

const NoMatch = () => {
  return <div>Not Found</div>;
};

export default NoMatch;
